import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTicketmasterComponent } from './simple-icons-ticketmaster.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTicketmasterComponent ],
    exports:      [ SimpleIconsTicketmasterComponent ],
    bootstrap:    []
})
export class SimpleIconsTicketmasterModule {}
